export { mainnet, } from "./mainnet";
export { mainnet8, } from "./mainnet8";
export { mainnet_test, } from "./mainnet_test";

export { arbitrum, } from "./arbitrum";
export { arbitrum8, } from "./arbitrum8";
export { arbitrum_test, } from "./arbitrum_test";

import type { ChainInfo, ValidChainName, } from "../types";

export const TESTABLE_HOSTS = [
	"localhost",
	"brenmono",
	"slaw",
	// "prod1",
	// "prod2",
];


export const ORDERED_CHAIN_DETAIL: Record<ValidChainName, ChainInfo> = {
	mainnet: {
		name: "mainnet",
		chainId: 1,
		icon: "/assets/mainnet.svg",
		label: "Ethereum",
		rule: () => true,
	},
	mainnet8: {
		name: "mainnet8",
		chainId: 18,
		icon: "/assets/mainnet.svg",
		label: "Ethereum8",
		rule: () => TESTABLE_HOSTS.some(host => window.location.href.includes(host)) || window.location.search.includes("testchains=true"),
	},
	mainnet_test: {
		name: "mainnet_test",
		chainId: 188,
		icon: "/assets/mainnet.svg",
		label: "Mainnet88",
		rule: () => TESTABLE_HOSTS.some(host => window.location.href.includes(host)) || window.location.search.includes("testchains=true"),
	},
	arbitrum: {
		name: "arbitrum",
		chainId: 42161,
		icon: "/assets/arbitrum.svg",
		label: "Arbitrum",
		rule: () => true,
	},
	arbitrum8: {
		name: "arbitrum8",
		chainId: 421618,
		icon: "/assets/arbitrum.svg",
		label: "Arbitrum8",
		rule: () => TESTABLE_HOSTS.some(host => window.location.href.includes(host)) || window.location.search.includes("testchains=true"),
	},
	arbitrum_test: {
		name: "arbitrum_test",
		chainId: 4216188,
		icon: "/assets/arbitrum.svg",
		label: "Arbitrum88",
		rule: () => TESTABLE_HOSTS.some(host => window.location.href.includes(host)) || window.location.search.includes("testchains=true"),
	},

};

export const getUsableChains = () => {
	return Object.entries(ORDERED_CHAIN_DETAIL).reduce((acc, [ key, detail]) => {
		if( typeof detail.rule === "function" ) {
			if(!detail.rule()) return acc;
		}
		return Object.assign(acc, { [key]: detail, });
	}, {} as Record<ValidChainName, ChainInfo>);
}
